import { fromSpecific, scope, TypedNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import type { JavaScriptNode, JavaScriptSpecific } from '../JavaScript'
import type { TransformerModel } from './ViewModel'
import type { TypedSpecificLike } from '@rehaje/core'

export interface TransformerSpecific extends TypedSpecificLike {
  /**
   * 依赖收集执行器
   */
  tracker?: Function | JavaScriptSpecific
  type: 'Transformer'
}

@scope({
  variables() {
    return [
      {
        get: () => {
          return this.getExposedViewModel<TransformerModel>()
        },
        group: 'Transformer',
        name: () => {
          return this.id
        },
        type: 'Block'
      }
    ]
  }
})
export class TransformerNode extends TypedNode {
  /*
   * 依赖收集执行器
   */
  @fromSpecific()
  @reactive()
  tracker?: JavaScriptNode | unknown
}

declare global {
  export interface RehajeSpecifics {
    Transformer: TransformerSpecific
  }
  export interface RehajeTypedNodes {
    Transformer: TransformerNode
  }
}
